"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
const react_1 = require("react");
const useInterval = (callback, delay, resetCondition) => {
    const [intervalId, setIntervalId] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        callback();
        const id = setInterval(callback, delay);
        setIntervalId(id);
        return () => clearInterval(id);
    }, [resetCondition]);
    return () => clearInterval(intervalId);
};
exports.useInterval = useInterval;
